<div class="px-2">
  <div class="partner_wrap">
    <form [formGroup]="partnerFilterForm">
      <div class="filter-section m-filter">
        <div class="row">
          <div class="col-md-6 col-sm-12 col-12">
            <div class="row">
              <div
                class="col-md-4 col-sm-4 col-6"
                *ngIf="userRole == 'companyManager' || userRole == 'companyEmployee'"
              >
                <mat-form-field class="mr-5 w-100">
                  <mat-label>User Type</mat-label>
                  <mat-select formControlName="userType">
                    <mat-option value="">All </mat-option>
                    <mat-option value="agent">Agent </mat-option>
                    <mat-option value="appraiser" *ngIf="appState.appCompanyAliasValue == 'valuetest'"
                      >Appraiser
                    </mat-option>
                    <mat-option value="loanOfficer">Loan Officer </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-4 col-sm-4 col-6">
                <mat-form-field class="mr-5 w-100">
                  <input
                    matInput
                    type="text"
                    placeholder="Name Or Email"
                    formControlName="userNameOrEmail"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>

              <div
                class="col-md-4 col-sm-4 col-6"
                *ngIf="shouldFetchReferrals()"  

              >
                <mat-form-field class="mr-5 w-100">
                  <mat-label>Source</mat-label>
                  <mat-select formControlName="source">
                    <mat-option value="">All </mat-option>
                    <mat-option value="compCheck">Comp Check </mat-option>
                    <mat-option value="valueTest">Value Test </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                class="col-md-4 col-sm-4 col-6"
                *ngIf="
                  userRole == 'clientManager' ||
                  userRole == 'amcEmployee' ||
                  userRole == 'companyManager' ||
                  userRole == 'companyEmployee'
                "
              >
                <mat-checkbox color="primary" (change)="getAllReferrals()" [checked]="allReferrals"
                  >Display All Referrals</mat-checkbox
                >
              </div>

              <div col-md-4 col-sm-4 col-6>
                <button
                  class="ml-1 float-left mb-2"
                  type="submit"
                  cdkFocusInitial
                  mat-flat-button
                  color="primary"
                  (click)="filter()"
                >
                  Filter
                </button>
                <button mat-stroked-button class="primary" class="ml-2 float-left mb-2" (click)="reset()">Reset</button>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-sm-12 col-12">
            <button
              class="ml-1 float-right mb-2"
              *ngIf="
                appState?.companyInfoValue.appConfig?.appraiserInvitation?.isEnabled &&
                (userRole == 'companyManager' || userRole == 'companyEmployee')
              "
              (click)="openInviteDialogBox('Appraiser')"
              type="submit"
              cdkFocusInitial
              mat-flat-button
              color="primary"
            >
              <i class="material-icons mr-1">person_add</i>Invite Appraiser
            </button>
            <button
              class="ml-1 float-right mb-2"
              *ngIf="
                appState?.companyInfoValue.appConfig?.loanOfficerInvitation?.isEnabled &&
                (userRole == 'agent' ||
                  userRole == 'companyManager' ||
                  userRole == 'clientManager' ||
                  userRole == 'amcEmployee' ||
                  userRole == 'companyEmployee')
              "
              (click)="openInviteDialogBox('Loan Officer')"
              type="submit"
              cdkFocusInitial
              mat-flat-button
              color="primary"
            >
              <i class="material-icons mr-1">person_add</i>Invite Loan Officer
            </button>
            <button
              class="ml-1 float-right mb-2"
              *ngIf="
                (canViewLoanOfficer &&
                  !((isValueTestCompany && userRole == 'amcEmployee') || userRole == 'clientManager')) ||
                (isValueTestCompany && userRole == 'companyEmployee')
              "
              (click)="openInviteDialogBox('Agent')"
              type="submit"
              cdkFocusInitial
              mat-flat-button
              color="primary"
            >
              <i class="material-icons mr-1">person_add</i>Invite Agent
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="section-in-progress" *ngIf="isDataLoading">
      <div class="spinner-content">
        <mat-spinner [diameter]="30"></mat-spinner>
        <span>Please wait while we load</span>
      </div>
    </div>
    <div
      class="legend float-md-left mt-4 mt-md-0"
      *ngIf="
        partnershipDetails &&
        partnershipDetails.length &&
        authorizeService.canView('defaultPartner') &&
        !appState?.companyInfoValue.appConfig?.valueReport?.isEnabled
      "
    >
      <img src="assets/images/default.png" /><span>Your default partner</span>
    </div>
    <div class="partnership-row" *ngIf="partnershipDetails && partnershipDetails.length">
      <mat-card class="partnership-card" *ngFor="let partner of partnershipDetails">
        <mat-card-content>
          <div class="partnerlogo" *ngIf="!appState?.companyInfoValue.appConfig?.valueReport?.isEnabled">
            <img [src]="partner.logo" height="100%" />
            <img
              src="assets/images/default.png"
              *ngIf="partner.isDefaultPartner"
              class="ml-1 mat-flat-button mat-primary ng-star-inserted partner_btn"
              width="18px"
            />
            <button
              *ngIf="!partner.isDefaultPartner && authorizeService.canView('defaultPartner') &&  partner?.status != 'pending'"
              [matTooltip]="'Set as Default'"
              class="ml-1 partner_btn"
              mat-flat-button
              (click)="setAsDefaultPartner(partner.connectionId)"
            >
              <i class="material-icons">star</i>
            </button>
          </div>
          <p class="w-100">
            {{ partner.firstName }} {{ partner.lastName }} -
            <span>{{ partner?.status === 'pending'
  ? (partner?.canAccept
      ? getMappedUserType(partner?.userType)
      : getMappedUserType(partner?.type))
  : getMappedUserType(partner?.userType)
}}</span>
          </p>

          <p *ngIf="partner.companyBrandingName" class="d-flex text-secondary mb-1">
            <mat-icon inline class="mr-2">business</mat-icon>
            {{ partner?.companyBrandingName }}
          </p>

          <p [matTooltip]="partner.email" class="d-flex text-secondary mb-1" style="line-break: anywhere">
            <mat-icon inline class="mr-2">email</mat-icon>
            {{ partner.email }}
          </p>
          <p class="d-flex text-secondary mb-1">
            <mat-icon inline class="mr-2">phone</mat-icon> {{ partner.phone || '--' }}
          </p>

          <div class="d-flex justify-content-between">
            <p
              matTooltip="Agent Website"
              class="mb-0 d-flex text-secondary"
              *ngIf="
  partner?.status !== 'pending' &&
  partner?.userType === 'agent' &&
  !appState?.companyInfoValue?.appConfig?.valueReport?.isEnabled
"
            >
              <mat-icon inline class="mr-2">public</mat-icon>
              <a
                [href]="'https://' + appState?.companyInfoValue?.baseUrl + '/portfolio/' + partner.shortId"
                target="_blank"
                class="text-secondary"
              >
                Website
              </a>
            </p>
            <p class="mb-0 text-secondary font-italic" *ngIf="partner.status != 'pending'">
              Since {{ (partner.connectedDate | simpleDate) || '--' }}
            </p>
            <p class="mb-0 text-secondary font-italic" *ngIf="partner.status == 'pending'">
              Invited on : {{ (partner.createdDate | simpleDate) || '--' }}
            </p>
  </div>
          <!-- <span class="status-badge" *ngIf="partner?.status == 'pending'">Invitation sent</span> -->
          <div class="partner-footer" *ngIf="partner?.status == 'pending' && !partner.canAccept">
            <span class="invitation-status pending"> Invitation Pending </span>
            <button mat-flat-button class="invitation-sent">Invitation Sent</button>
          </div>
          <div class="partner-footer" *ngIf="partner.canAccept"  >
            <span class="invitation-status received"> Invitation Received </span>
            <button  [pmx-progress-button]="isProgress"   mat-flat-button class="accept-btn" (click)="acceptInvitation(partner)">Accept</button>
          </div>
          <div class="partner-footer" *ngIf="partner?.status != 'pending'">
            <span class="invitation-status connected">connected </span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div>
      <mat-paginator
        class="my-5"
        [length]="activePartnersCount"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPartnersPageChange($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
    <!-- <div class="legend" *ngIf="partnershipDetails && partnershipDetails.length">
      <img src="assets/images/default.png"><span>Your default partner</span>
    </div> -->
    <div class="nopartner text-center py-4" *ngIf="!partnershipDetails || !partnershipDetails.length">
      <img src="assets/images/partnerholder.png" width="260px" />
      <h5>Your partners will be listed here</h5>
    </div>
  </div>
  <ng-template #inviteAgentDialog>
    <button *ngIf="!loadEmailTemplate" class="close" mat-button type="button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <form #form="ngForm" [formGroup]="agentInviteForm">
      <div *ngIf="loadEmailTemplate">
        <app-email-template [data]="htmlData" (onBack)="hideEmailTemplate($event)"></app-email-template>
      </div>
      <div *ngIf="!loadEmailTemplate" class="addGroupWrap">
        <h2 matDialogTitle class="text-center">Invite {{ inviteUserType }}</h2>
        <div mat-dialog-content class="pt-2">
          <mat-form-field class="w-100">
            <mat-label>First Name </mat-label>
            <input formControlName="firstName" matInput type="text" required />
            <mat-error
              *ngIf="formControls.firstName.errors && formControls.firstName.errors.required"
              class="invalid-feedback"
            >
              First Name is required</mat-error
            >
            <mat-error
              *ngIf="formControls.firstName.errors && formControls.firstName.errors.maxlength"
              class="invalid-feedback"
            >
              Maximum 25 characters are allowed</mat-error
            >
            <mat-error
              *ngIf="formControls.firstName.errors && formControls.firstName.errors.pattern"
              class="invalid-feedback"
            >
              Only alphabets are allowed</mat-error
            >
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Last Name </mat-label>
            <input formControlName="lastName" matInput type="text" />
            <mat-error
              *ngIf="formControls.lastName.errors && formControls.lastName.errors.pattern"
              class="invalid-feedback"
              >Only alphabets are allowed</mat-error
            >
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Email </mat-label>
            <input formControlName="email" matInput type="email" required />
            <mat-error *ngIf="formControls.email.errors && formControls.email.errors.required" class="invalid-feedback">
              Email is required</mat-error
            >
            <mat-error *ngIf="formControls.email.errors && formControls.email.errors.pattern" class="invalid-feedback">
              Email must be a valid</mat-error
            >
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label>Phone Number </mat-label>
            <input formControlName="phone" matInput />
            <mat-error *ngIf="formControls.phone.errors && formControls.phone.errors.pattern" class="invalid-feedback">
              Phone number must be valid</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <mat-dialog-actions>
        <div class="w-100 text-right">
          <button
            *ngIf="isLoanOfficer && !loadEmailTemplate && appState.companyInfoValue.alias == 'valuetest'"
            class="mr-1"
            cdkFocusInitial
            mat-stroked-button
            color="primary"
            (click)="fetchEmailTemplate()"
            type="submit"
          >
            Preview
          </button>
          <button class="ml-1" type="submit" cdkFocusInitial mat-flat-button color="primary" (click)="inviteUser()">
            Invite
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  </ng-template> 
